import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "cart-checkout__activate" };
const _hoisted_2 = { class: "mb-2 ml-2" };
const _hoisted_3 = { class: "fw-bold" };
const _hoisted_4 = { class: "mb-4 data-box__card" };
const _hoisted_5 = { class: "item" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_cart_profile_login = _resolveComponent("g-cart-profile_login");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h6", _hoisted_3, _toDisplayString(_ctx.$tc('client.Commerce.Carts.ProfileActivate')), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", null, [
                    _createVNode(_component_g_cart_profile_login, {
                        onLoggedin: _ctx.loadAfterLogin,
                        mode: "activate-inline",
                        data: _ctx.user
                    }, null, 8, ["onLoggedin", "data"])
                ])
            ])
        ])
    ]));
}
